'use client';
import { max, min } from '../math.js';

/**
 * Ограничивает входное численное значение снизу и сверху.
 *
 * @example
 * ```ts
 * clamp(10, [0, 5]) // 5
 * clamp(-10, [-2, 5]) // -2
 * clamp(0, [-1, 1]) // 0
 * ```
 * */ var clamp = function(value, param) {
    var _min = param[0], _max = param[1];
    return max(_min, min(value, _max));
};

export { clamp };
